 import React, { useState } from "react";
import Layout from "../components/Layout";
import draftScripts from "../components/DraftScripts";

function DisplayDrafts() {
  // 1) SEARCH STATE
  const [searchQuery, setSearchQuery] = useState("");

  // 2) FILTER LOGIC
  const filteredDrafts = draftScripts.filter((draft) => {
    // Combine all text fields into one string
    const combinedText = [
      draft.goalOfTheDraft,
      draft.subjectLine,
      draft.tellUsAboutYou,
      // Join the array for purposeOfYourEmail
      ...(draft.purposeOfYourEmail || [])
    ]
      .join(" ")
      .toLowerCase();

    // Check if searchQuery is included
    return combinedText.includes(searchQuery.toLowerCase());
  });

  return (
    <Layout>
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Draft Templates
        </h1>

        {/* 3) SEARCH BAR */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search drafts..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border p-2 w-full rounded-md"
          />
        </div>

        {/* Mobile view: Card layout for small screens */}
        <div className="block md:hidden">
          {filteredDrafts.length === 0 ? (
            <p className="text-center text-gray-500">
              No drafts match your search.
            </p>
          ) : (
            filteredDrafts.map((draft) => (
              <div
                key={draft.id}
                className="bg-white rounded-lg shadow mb-4 p-4 border border-gray-200"
              >
                <div className="mb-2">
                  <span className="font-semibold">#:</span> {draft.id}
                </div>
                <div className="mb-2">
                  <span className="font-semibold">Goal of the Draft:</span>{" "}
                  {draft.goalOfTheDraft}
                </div>
                <div className="mb-2">
                  <span className="font-semibold">Subject Line:</span>{" "}
                  {draft.subjectLine}
                </div>
                <div className="mb-2">
                  <span className="font-semibold">Purpose of Your Email:</span>
                  <ul className="list-disc list-inside ml-4 mt-1">
                    {draft.purposeOfYourEmail.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <span className="font-semibold">
                    Tell Us About You – Your Story:
                  </span>{" "}
                  {draft.tellUsAboutYou}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Desktop view: Table layout for medium screens and above */}
        <div className="hidden md:block overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr>
                <th className="py-3 px-6 bg-gray-100 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  #
                </th>
                <th className="py-3 px-6 bg-gray-100 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Goal of the Draft
                </th>
                <th className="py-3 px-6 bg-gray-100 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Subject Line
                </th>
                <th className="py-3 px-6 bg-gray-100 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Purpose of Your Email
                </th>
                <th className="py-3 px-6 bg-gray-100 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Tell Us About You – Your Story
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredDrafts.map((draft) => (
                <tr key={draft.id} className="border-t">
                  <td className="py-4 px-6 text-sm text-gray-700">
                    {draft.id}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-700">
                    {draft.goalOfTheDraft}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-700">
                    {draft.subjectLine}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-700">
                    <ul className="list-disc list-inside">
                      {draft.purposeOfYourEmail.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-700">
                    {draft.tellUsAboutYou}
                  </td>
                </tr>
              ))}
              {/* If no results, show a message */}
              {filteredDrafts.length === 0 && (
                <tr>
                  <td
                    colSpan="5"
                    className="py-4 px-6 text-center text-gray-500"
                  >
                    No drafts match your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default DisplayDrafts;
